import { GetterTree } from "vuex";

import { RootState } from "@/store";

import { State } from "./state";

export type Getters = {
  alertConditionCats(state: State): Array<any>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  alertConditionCats: (state) => state.alertConditionCats,
};
